import collection from "@/store/collection.store-partial";
import budgetModule from "@/store/game/budgets/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	state: {},
	getters: {
		count: (state, getters) => getters.array.length,
		funds: (state, getters) => getters.array.filter((budget) => budget.type === "fund"),
		scores: (state, getters) => getters.array.filter((budget) => budget.type === "score"),
		allocated: (state, getters) => getters.array.reduce((sum, budget) => sum + budget.allocated, 0),
		unallocated: (state, getters, rootState) => rootState.game.balance.amount - getters.allocated,
	},
	actions: {
		configureApp: {
			root: true,
			handler({ dispatch }, configData) {
				dispatch("populate", {
					items: configData.budgets,
					path: ["game", "budgets"],
					module: budgetModule,
				});
			},
		},
		reset({ getters, dispatch }) {
			getters.array.forEach((budget) => {
				dispatch(`${budget.id}/reset`);
			});
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/budgets/list.store.js